export const BACKEND_TO_FORMIK: Record<string, string> = {
  "body.type": "projectType",
  "body.name": "projName",
  "body.contractValue": "projValue",
  "body.contractValue.amount": "projValue",
  "body.description": "projDesc",
  "body.address": "projAddr",
  "body.stakeholders.ownerId": "ownerId",
  "body.stakeholders.ownerPrimaryContact": "ownerPhone",
  "body.stakeholders.requisitionSignerName": "reqSigner",
  "body.stakeholders.requisitionSignerPrimaryPhone": "reqPhone",
  "body.stakeholders.requisitionSignerPhone": "reqPhone",
  "body.stakeholders.requisitionSignerEmail": "reqEmail",
  "body.stakeholders.requisitionSignerAddress": "reqAddr",
  "body.stakeholders.gcId": "gcId",
  "body.stakeholders.gcPrimaryContact": "gcPhone",
  "body.stakeholders.architectId": "architect",
  "body.stakeholders.ownerRepresentative": "ownerRep",
  "body.stakeholders.otherProjectEntities": "otherEntities",
  "body.stakeholders.lenderId": "lenderBranchId",
  "body.stakeholders.lendingOfficerId": "lendingOfficerId",
  "body.stakeholders.lenderReportingCc": "ccList",
  "body.settings.preConstructionReviewDueDate": "preconDate",
};

export const FIELD_LABELS: Record<string, string> = {
  projectType: "Project Type",
  projName: "Project Name",
  projValue: "Contract Value",
  projDesc: "Project Description",
  projAddr: "Project Address",
  ownerId: "Owner",
  ownerPhone: "Owner Primary Contact",
  reqSigner: "Requisition Signer Name",
  reqPhone: "Requisition Signer Phone",
  reqEmail: "Requisition Signer Email",
  reqAddr: "Requisition Signer Address",
  gcId: "General Contractor",
  gcPhone: "GC Primary Contact",
  architect: "Architect",
  ownerRep: "Owner's Representative",
  otherEntities: "Other Entities",
  ccList: "CC on Reports",
  lenderBankId: "Bank",
  lenderBranchId: "Branch",
  lendingOfficerId: "Lending Officer",
  preconDate: "Pre-Construction Report Date",
};

export const FIELD_STEP: Record<string, number> = {
  projectType: 1,
  projName: 2,
  projValue: 2,
  projDesc: 2,
  projAddr: 2,
  ownerId: 3,
  ownerPhone: 3,
  reqSigner: 3,
  reqPhone: 3,
  reqEmail: 3,
  reqAddr: 3,
  gcId: 3,
  gcPhone: 3,
  architect: 3,
  ownerRep: 3,
  otherEntities: 3,
  ccList: 3,
  lenderBankId: 4,
  lenderBranchId: 4,
  lendingOfficerId: 4,
  preconDate: 5,
};

interface NormalizeApiErrorsResult {
  formikErrors: Record<string, string>;
  touchedFields: Record<string, boolean>;
  firstStep: number | null;
}

const cleanBackendMessage = (rawMessage: string): string => {
  const stripped = rawMessage.replace(/^[\w.]+\s+/, "");
  return stripped.replace(/^[a-z]/, (c) => c.toUpperCase()) || rawMessage;
};

export const normalizeApiErrors = (
  backendFields: Record<string, string> | null | undefined,
): NormalizeApiErrorsResult => {
  const formikErrors: Record<string, string> = {};
  const touchedFields: Record<string, boolean> = {};
  let firstStep = Infinity;

  if (!backendFields || typeof backendFields !== "object") {
    return { formikErrors, touchedFields, firstStep: null };
  }

  Object.entries(backendFields).forEach(([backendPath, rawMessage]) => {
    const formikKey = BACKEND_TO_FORMIK[backendPath];
    if (!formikKey) return;

    const label = FIELD_LABELS[formikKey] ?? formikKey;
    formikErrors[formikKey] = `${label}: ${cleanBackendMessage(rawMessage)}`;
    touchedFields[formikKey] = true;

    const step = FIELD_STEP[formikKey];
    if (step !== undefined && step < firstStep) firstStep = step;
  });

  return {
    formikErrors,
    touchedFields,
    firstStep: firstStep === Infinity ? null : firstStep,
  };
};
